import React from 'react';
import { useBMTheme } from '../../theme';
import { Path, Svg } from 'react-native-svg';
export default function useDateCellAdditionalSlotRenderer(componentType) {
    const { BMComponents } = useBMTheme();
    let svgProps = undefined;
    let pathProps = undefined;
    switch (componentType) {
        case 'bar': {
            svgProps = {
                width: 22,
                height: 6,
            };
            pathProps = {
                d: 'M3 3 L19 3',
                stroke: BMComponents.BMStyleIconInkHighlightGreen,
                strokeWidth: 6,
                strokeLinecap: 'round',
            };
            break;
        }
        case 'dot': {
            svgProps = {
                width: 6,
                height: 6,
            };
            pathProps = {
                d: 'M3 3 L3 3',
                stroke: BMComponents.BMStyleIconInkHighlightGreen,
                strokeWidth: 6,
                strokeLinecap: 'round',
            };
            break;
        }
        case 'circle': {
            svgProps = {
                width: 16,
                height: 16,
            };
            pathProps = {
                d: 'M8 8 m6 0 a6 6 0 1 0 -12 0 a6 6 0 1 0 12 0',
                stroke: BMComponents.BMStyleIconInkAction,
                strokeWidth: 4,
                fill: 'transparent',
            };
            break;
        }
        case 'triangle': {
            svgProps = {
                width: 16,
                height: 16,
            };
            pathProps = {
                d: 'M2 13 L8 2 L14 13 Z',
                stroke: BMComponents.BMStyleIconInkHighlightYellow,
                strokeWidth: 4,
                strokeLinejoin: 'round',
                fill: 'transparent',
            };
            break;
        }
        case 'cross': {
            svgProps = {
                width: 15,
                height: 15,
            };
            pathProps = {
                d: 'M2 2 L13 13 M13 2 L2 13',
                stroke: BMComponents.BMStyleIconInkSecondary,
                strokeWidth: 4,
                strokeLinecap: 'round',
                fill: 'transparent',
            };
            break;
        }
        default: {
            break;
        }
    }
    if (pathProps && svgProps) {
        return (<Svg {...svgProps}>
        <Path {...pathProps}/>
      </Svg>);
    }
    return undefined;
}
